import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

export const getDateWithin7Days = (dateType: string): boolean => {
  return (
    differenceInCalendarDays(new Date(dateType), new Date()) <= 7 &&
    differenceInCalendarDays(new Date(dateType), new Date()) > -1
  );
};
